import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";

import * as Auth from "../../authService";
import mannifestLogo from "../../icons/ic-transaction-mannifest@3x.png";
import Spinner from "../HelperComponents/Spinner";
import VtUserManagementTable from "./VtUserManagementTable";

const VtUserManagement = () => {
  const [loading, setLoading] = useState(false);

  if (!Auth.loggedIn()) {
    return <Navigate to="/login" replace />;
  }

  if (!Auth.canViewUserManagement()) {
    return <Navigate to="/summary" replace />;
  }

  return (
    <main className="main-background">
      <div className="main-component">
        <div id="table-header">
          <div id="details-label">
            <img
              alt="Govpay Logo"
              src={mannifestLogo}
              id="trans-manifest-icon"
            />
            <div id="details-label-name">Onsite Payment Agents</div>
          </div>
          <Spinner customClass={"sk-fading-circle summary"} loading={loading} />
        </div>
        <VtUserManagementTable setSpinner={setLoading} loading={loading} />
      </div>
      <ToastContainer transition={Slide} />
    </main>
  );
};

export default VtUserManagement;
